module.exports = __webpack_public_path__ + "static/img/software31.8424e123.png";